export default function PreviewPolicies({ config }) {
  const p = config?.website?.policies || {};
  const items = (p.items || []).filter((x) => x.enabled);

  return (
    <section style={{ padding: "0 24px 26px" }}>
      <div
        style={{
          borderRadius: "var(--ns-radius-lg)",
          background: "var(--ns-card)",
          border: "1px solid var(--ns-card-border)",
          boxShadow: "var(--ns-shadow)",
          padding: 18
        }}
      >
        <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
          <div style={{ width: 10, height: 10, borderRadius: 999, background: "var(--ns-primary)" }} />
          <h3 style={{ margin: 0, color: "var(--ns-ink)", fontWeight: 950, fontSize: 18 }}>
            {p.title || "Reservation Policies"}
          </h3>
        </div>

        <div style={{ marginTop: 14 }}>
          {items.length === 0 ? (
            <div style={{ color: "var(--ns-muted)", fontSize: 13 }}>
              Add policies to show them here.
            </div>
          ) : (
            <div style={{ display: "grid", gap: 12 }}>
              {items.map((it) => (
                <div
                  key={it.key}
                  style={{
                    padding: 16,
                    borderRadius: 16,
                    background: "rgba(15,23,42,0.03)",
                    border: "1px solid rgba(15,23,42,0.08)"
                  }}
                >
                  <div style={{ color: "var(--ns-ink)", fontWeight: 950, marginBottom: 8 }}>
                    {it.label}
                  </div>
                  <div
                    style={{ color: "rgba(11,18,32,0.78)", lineHeight: 1.7, fontSize: 13 }}
                    dangerouslySetInnerHTML={{ __html: it.descriptionHtml || "" }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
